// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2KixH","fitToLayout":"_2C0u6"};